import React, { useState, useEffect } from "react";
import axios from 'axios';
import { alert_error, alert_success } from "../../AppContext.js";
import StatusBadge from "../../js/buttonstatus.jsx";
import Video_check_time from "./video_check_time"; // import component con

const MyTableComponent = () => {
    // States
    const [id_orders, set_id_orders] = useState('');
    const [username, set_username] = useState('');
    const [chedo, set_chedo] = useState('');
    const [value, set_value] = useState('');
    const [note, set_note] = useState('');
    const [money, set_money] = useState('');
    const [start_count, set_start_count] = useState('');
    const [url, set_url] = useState('');
    const [status, set_status] = useState('');
    const [modePercent, setModePercent] = useState(100); // NEW: phần trăm mode (numeric)
    const [loadingSubmit, setLoadingSubmit] = useState(false); // NEW: trạng thái submit
    const [category, set_category] = useState('');

    const options_status = [
        { id: 0, name: "-- Chưa chọn --", value: "" },
        { id: 1, name: "Processing", value: "Processing" },
        { id: 2, name: "In progress", value: "In progress" },
        { id: 3, name: "Completed", value: "Completed" },
        { id: 4, name: "Canceled", value: "Canceled" },
    ];

    const [data, set_data] = useState([]);

    const fetchData = () => {
        axios.get('https://hust.media/hustadmin_v2/videos_check.php', {
            params: {
                id_orders: id_orders,
                username: username,
                status: status,
                category: category
            }
        })
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    };
    function testFunction(response) {
        set_data(response.data);
    }

    useEffect(() => {
        fetchData();
    }, []);

    const handleInputChange1 = (event) => {
        set_username(event.target.value);
    };
    const handleInputChange2 = (event) => {
        set_id_orders(event.target.value);
    };
    const change_value = (event) => {
        set_value(event.target.value);
    };
    const change_note = (event) => {
        set_note(event.target.value);
    };
    const change_money = (event) => {
        set_money(event.target.value);
    };
    const change_url = (event) => {
        set_url(event.target.value);
    };

    const member_edit = (event) => {
        event.preventDefault();
        setLoadingSubmit(true); // Bật trạng thái chờ

        // chuẩn hoá mode gửi lên: chỉ số số nguyên
        const modeToSend = parseInt(modePercent, 10) || 0;

        axios.get('https://hust.media/hustadmin_v2/videos_check_edit.php', {
            params: {
                id_orders: value,
                chedo: chedo,
                note: note,
                money: money,
                start_count: start_count,
                url: url,
                mode: modeToSend
            },
            timeout: 12000 // 12 giây
        })
            .then((response) => {
                testFunction2(response);
            })
            .catch((error) => {
                alert_error(error);
            })
            .finally(() => {
                setLoadingSubmit(false); // Luôn bật lại nút sau khi API xong
            });
    };
    function testFunction2(response) {
        alert_success(response.data);
        fetchData();
        closeModal();
    }

    const [isModalVisible, setModalVisible] = useState(false);
    const closeModal = () => setModalVisible(false);

    const [users_edit, set_users_edit] = useState('');

    const openModal = (row) => {
        set_users_edit(row);
        setModalVisible(true);
    };

    const options = [
        { id: 1, name: 'Completed_auto', value: 'Completed_auto' },
        { id: 2, name: 'Processing', value: 'Processing' },
        { id: 3, name: 'In progress', value: 'In progress' },
        { id: 4, name: 'Completed', value: 'Completed' },
        { id: 5, name: 'Canceled', value: 'Canceled' },
    ];

    const percentOptions = Array.from({ length: 11 }, (_, i) => i * 10);

    useEffect(() => {
        if (users_edit?.id) {
            set_value(users_edit.id);
        }
    }, [users_edit]);

    const change_chedo = (event) => {
        const selectedValue = event.target.value;
        set_chedo(selectedValue);
        if (selectedValue === 'Completed_auto') {
            setModePercent(100);
        }
        console.log(`Selected option: ${selectedValue}`);
    };

    return (
        <div className="card-body mx-2 my-2">
            <div className="flex">
                {!isModalVisible ? null : (
                    <div className="App">
                        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                            <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
                                <h2 className="text-lg font-semibold mb-2">Chỉnh sửa</h2>
                                <form onSubmit={member_edit}>
                                    <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">
                                            id_orders {users_edit.id}
                                            <div>Username {users_edit.username}</div>
                                        </label>

                                        <select
                                            id="select"
                                            value={chedo}
                                            onChange={change_chedo}
                                            className="mb-2 block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                                        >
                                            <option value="" disabled>Select an option</option>
                                            {options.map((option) => (
                                                <option key={option.id} value={option.value || option.name}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>

                                        {chedo === 'Completed_auto' && (
                                            <div className="mb-3">
                                                <label className="block text-sm mb-1">Mode (phần trăm)</label>
                                                <select
                                                    value={modePercent}
                                                    onChange={(e) => setModePercent(parseInt(e.target.value, 10))}
                                                    className="block w-full border rounded p-2"
                                                >
                                                    {percentOptions.map((p) => (
                                                        <option key={p} value={p}>
                                                            {p}%
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        )}

                                        {(chedo === 'Processing' || chedo === 'In progress' || chedo === 'Completed' || chedo === 'Canceled') && (
                                            <>
                                                <input
                                                    onChange={change_value}
                                                    value={value}
                                                    type="text"
                                                    id="value"
                                                    placeholder="value"
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
                                                />
                                                <input
                                                    onChange={change_note}
                                                    value={note}
                                                    type="text"
                                                    id="note"
                                                    placeholder="note: kết quả"
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
                                                />
                                                <input
                                                    onChange={change_money}
                                                    value={money}
                                                    type="text"
                                                    id="money"
                                                    placeholder="money: tiền cộng"
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline mb-2"
                                                />
                                            </>
                                        )}
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <button
                                            type="submit"
                                            disabled={loadingSubmit}
                                            className={`font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline ${loadingSubmit ? "bg-gray-400 cursor-not-allowed text-white" : "bg-blue-500 hover:bg-blue-700 text-white"
                                                }`}
                                        >
                                            {loadingSubmit ? "Đang xử lý..." : "Submit"}
                                        </button>
                                        <button
                                            onClick={closeModal}
                                            type="button"
                                            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                        >
                                            Close
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                )}

                <div className="flex flex-col gap-4 w-full max-w-xl">
                    {/* Hàng 1: username + id_orders */}
                    <div className="flex gap-4">
                        <div className="flex gap-2 flex-1">
                            <input
                                type="text"
                                placeholder="username"
                                value={username}
                                onChange={(event) => set_username(event.target.value)}
                                className="border rounded p-2 flex-1"
                            />
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>

                        <div className="flex gap-2 flex-1">
                            <input
                                type="text"
                                placeholder="id_orders"
                                value={id_orders}
                                onChange={(event) => set_id_orders(event.target.value)}
                                className="border rounded p-2 flex-1"
                            />
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>
                    </div>

                    {/* Hàng 2: status + category */}
                    <div className="flex gap-4">
                        <div className="flex gap-2 flex-1">
                            <select
                                value={status}
                                onChange={(e) => set_status(e.target.value)}
                                className="border rounded p-2 flex-1"
                            >
                                {options_status.map((opt) => (
                                    <option key={opt.id} value={opt.value}>
                                        {opt.name}
                                    </option>
                                ))}
                            </select>
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>

                        <div className="flex gap-2 flex-1">
                            <input
                                type="text"
                                placeholder="category"
                                value={category}
                                onChange={(event) => set_category(event.target.value)}
                                className="border rounded p-2 flex-1"
                            />
                            <button
                                onClick={() => fetchData()}
                                className="bg-blue-500 text-white px-1 rounded"
                            >
                                search
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full overflow-x-auto">
                <table className="table-fixed border-collapse w-full">
                    <colgroup>
                        <col className="w-1/12" />
                        <col className="w-2/12" />
                        <col className="w-1/12" />
                        <col className="w-3/12" />
                        <col className="w-1.5/12" />
                        <col className="w-1/12" />
                        <col className="w-1/12" />
                    </colgroup>
                    <thead>
                        <tr>
                            <th className="border text-center py-2">id_orders</th>
                            <th className="border text-center py-2">Username<br />api_category</th>
                            <th className="border text-center py-2">Money</th>
                            <th className="border text-center py-2">media</th>
                            <th className="border text-center py-2">note</th>
                            <th className="border text-center py-2">status <br />jobs</th>
                            <th className="border text-center py-2">THAO TÁC</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row) => (
                            <tr key={row.url_videos || row.id} className="break-words">
                                <td className="border text-center py-2">{row.id}</td>
                                <td className="border text-center py-2"><b>{row.username}</b>    <br />
                                    {row.api_category} <br />
                                    {row.box_name && (<>{row.box_name}</>)}
                                    <br />
                                    {row.box_description && (<>{row.box_description}</>)}
                                </td>
                                <td className="border text-center py-2">{row.money}</td>
                                {String(row.category_code || "").toLowerCase().includes("video") && row.url_videos ? (
                                    <Video_check_time row={row} />
                                ) : (
                                    <>
                                        <td className="border text-center py-2">
                                            {row.category_code === "images_check" && row.url_videos && (
                                                <img
                                                    src={row.url_videos}
                                                    alt="Ảnh"
                                                    className="mx-auto max-w-full h-auto max-h-[350px]"
                                                />
                                            )}
                                        </td>
                                        <td className="border text-center py-2">
                                            <div className="mb-1">{row.note}</div>
                                            <div>{row.worker?.[0]?.media_link_url}</div>
                                            <div>{row.worker?.[0]?.media_link_phone}</div>
                                        </td>
                                    </>
                                )}

                                <td className="border text-center py-2">
                                    <div className="mb-1"><StatusBadge status={row.status} /></div>
                                    <div>{row.createdate}</div>
                                    <div>{row.updatedate}</div>
                                </td>
                                <td className="border text-center py-2">
                                    <div onClick={() => openModal(row)} className="btn btn-default cursor-pointer">
                                        <i className="fas fa-edit"></i> Edit
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyTableComponent;
